export default __webpack_public_path__ + "static/media/fourth.7ffde04d.png";